import { createSlice } from '@reduxjs/toolkit';
import {
  fetchMeetingNotesThunk,
  createMeetingNoteThunk,
  updateMeetingNoteThunk,
  deleteMeetingNoteThunk,
} from './meetingNotesActionThunks';

const initialState = {
  notes: [],
  loading: { notes: false, mutate: false },
  errors: { notes: null, mutate: null },
};

const meetingNotesSlice = createSlice({
  name: 'meetingNotes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // === List ===
      .addCase(fetchMeetingNotesThunk.pending, (state) => {
        state.loading.notes = true;
        state.errors.notes = null;
      })
      .addCase(fetchMeetingNotesThunk.fulfilled, (state, action) => {
        state.notes = action.payload;
        state.loading.notes = false;
      })
      .addCase(fetchMeetingNotesThunk.rejected, (state, action) => {
        state.loading.notes = false;
        state.errors.notes = action.payload || 'Failed to load meeting notes';
      })

      // === Create ===
      .addCase(createMeetingNoteThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(createMeetingNoteThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.notes.unshift(action.payload);
      })
      .addCase(createMeetingNoteThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to create meeting note';
      })

      // === Update ===
      .addCase(updateMeetingNoteThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(updateMeetingNoteThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        const idx = state.notes.findIndex((n) => n.id === action.payload.id);
        if (idx !== -1) state.notes[idx] = action.payload;
      })
      .addCase(updateMeetingNoteThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to update meeting note';
      })

      // === Delete ===
      .addCase(deleteMeetingNoteThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(deleteMeetingNoteThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.notes = state.notes.filter((n) => n.id !== action.payload);
      })
      .addCase(deleteMeetingNoteThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to delete meeting note';
      });
  },
});

export default meetingNotesSlice.reducer;
